module.exports = __webpack_public_path__ + "img/swamt_back.01a3471d.png";